
export interface Revision<T> {
    previous: T;
    current: T;
}
